import { useContext } from 'react';

import { RequestGatewayContext } from './RequestGatewayContext';

export const useRequestGatewayContext = () => {
  const context = useContext(RequestGatewayContext);

  if (!context || !context.baseUrl || !context.refreshTokenUrl) {
    throw new Error(
      'useRequestGatewayContext must be used within a RequestGatewayProvider'
    );
  }

  return context;
};
